<template>
  <CFooter :fixed="false">
    <div class="ml-auto">
      <keep-alive v-if="this.user && this.user.rolename != 'client'">
        <t-clipboard :show="$store.state.showClipboard" />
      </keep-alive>

      <!-- <b-link
        v-if="this.user && this.user.rolename != 'client'"
        @click="$store.state.showClipboard = true"
        size="sm"
        class="pr-4"
      >
        <i
          :class="
            $store.state.clipboard
              ? 'fa fa-paste text-primary'
              : 'fa fa-paste text-secondary'
          "
        ></i>
        Clipboard
      </b-link> -->

      <span v-if="permissionvalid('navigation.help')">
        <a v-if="this.user && this.user.rolename != 'client'"
          href="mailto:backoffice@travelplaces.co.uk?subject=New Support Request&body=Hello, please describe the issue in detail with any steps to reproduce. Attach any screenshots."
          class="pr-4"><i class="fa fa-envelope pr-2"></i>New
          Support Request</a>
        <a v-if="this.user && this.user.rolename != 'client'" href="https://travelplaces.stoplight.io/docs/backoffice"
          target="_blank" class="pl-2"><i class="fa fa-question-circle pr-2"></i>Help</a>
        <a v-if="this.user && this.user.rolename == 'client'" href="https://travelplaces.stoplight.io/docs/eclient"
          target="_blank" class="pl-2"><i class="fa fa-question-circle pr-2"></i>Help</a>
        <a v-if="this.user && this.user.rolename != 'client'" href="https://travelplaces.stoplight.io/docs/api"
          target="_blank" class="pl-2"><i class="fa fa-question-circle pr-2"></i>API</a>
        <a v-if="this.user && this.user.rolename != 'client'" href="https://travelplaces.stoplight.io/docs/ticketsapi"
          target="_blank" class="pl-2"><i class="fa fa-question-circle pr-2"></i>TicketsAPI</a>
      </span>
      <span v-if="permissionvalid('navigation.systems')">
        <b-link v-if="this.user && this.user.rolename != 'client'" :to="'/apps/Systems'" class="pl-2"><i
            class="fa fa-heartbeat pr-2"></i>Systems</b-link>
      </span>
      <!-- <span class="mr-1" target="_blank">Powered by</span> -->
      <a class="pl-4" href="https://www.travelplaces.co.uk" target="_blank">Travel Places</a>
      <span class="ml-1">&copy; {{ new Date().getFullYear() }}</span>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: "TheFooter",
};
</script>
